<template>
  <div class="ls-select" >
    <el-popover
      placement="bottom"
      trigger="click"
      popper-class="ls-select-popover"
      @hide="handelHide"
      @show="handelShow"
      v-model="visible"
    >
      <div class="ls-select-content">
        <slot v-if="data.length <= 0"></slot>
        <div
          v-for="item in data"
          :key="item[props.key]"
          class="select-item"
          :class="getSelectItemClass(item[props.key])"
          @click="selectItemClick($event, item[props.key])"
        >
          {{ item[props.label] }}
        </div>
      </div>
      <div slot="reference" class="overflow-hidden">
        <el-input
          size="small"
          :class="isFocus"
          :placeholder="placeholder"
          v-model="searchValue"
          readonly
        >
          <i slot="suffix" class="el-input__icon el-icon-arrow-up" :class="arrowReverse"></i>
        </el-input>
        <div v-if="selectValues" class="select-values-cell">{{ selectValues }}</div>
      </div>

    </el-popover>

  </div>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'selectChange'
  },
  props: {
    placeholder: {
      type: String,
      default: '请选择'
    },
    data: {
      type: Array,
      default: () => {
        return []
      }
    },
    props: {
      type: Object,
      default: () => {
        return {
          key: 'id',
          label: 'name'
        }
      }
    },
    multiple: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      searchValue: '',
      focused: false,
      selected: [],
      visible: false
    }
  },
  computed: {
    arrowReverse() {
      if (this.focused) {
        return 'is-reverse'
      } else {
        return ''
      }
    },
    isFocus() {
      if (this.focused) {
        return 'is-focus'
      } else {
        return ''
      }
    },
    selectValues() {
      if (this.data.length <= 0) {
        return ''
      } else {
        const values = []
        this.selected.map(item => {
          const result = this.data.find(f => f[this.props.key] == item)
          if (result) {
            values.push(result[this.props.label])
          }
        })
        if (values.length > 0) {
          return values.join('/')
        } else {
          return ''
        }
      }
    }
  },
  watch: {
    value(data) {
      this.selected = [...data]
    }
  },
  methods: {
    handelShow() {
      this.focused = true
    },
    handelHide() {
      this.focused = false
    },
    handelClick() {
      this.focused = !this.focused
    },
    getSelectItemClass(data) {
      let classlist = []
      // 是否多选
      if (this.multiple) {
        classlist.push('is-multiple')
      }
      // 是否选中
      const index = this.selected.findIndex(f => f == data)
      if (index != -1) {
        classlist.push('is-selected')
      }
      return classlist.join(' ')
    },
    selectItemClick(event, data) {
      const index = this.selected.findIndex(f => f == data)
      if (index != -1) {
        this.selected.splice(index, 1)
      } else {
        this.selected.push(data)
      }
      this.$emit('selectChange', this.selected)
      this.$emit('change', this.selected)
    },
    hiddenPoperOver() {
      this.visible = false
    }
  }
}
</script>

<style lang="less">
.ls-select {
  display: inline-block;
  position: relative;
  .el-input {
    .is-reverse {
      transform: rotateZ(180deg);
    }
  }
  .is-focus {
    .el-input__inner {
      border-color: #007AFF;
    }
  }
  .el-input__inner {
    cursor: pointer;
  }

  .select-values-cell {
    position: absolute;
    top: 2px;
    left: 15px;
    right: 30px;
    bottom: 2px;
    line-height: 28px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    background-color: #fff;
    cursor: pointer;
  }
}

.ls-select-popover {
  padding: 0;
}
.ls-select-content {
  min-width: 194px;
  max-width: 260px;
  padding: 6px 0;
  max-height: 240px;
  overflow-y: auto;
  position: relative;
  .select-item {
    padding: 0 20px;
    height: 34px;
    line-height: 34px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    &:hover {
      color: #007AFF;
      background-color: #ecf5ff;
    }
  }
  .is-multiple {
    padding-right: 40px;
  }
  .is-selected {
    color: #007AFF;
    &:after {
      position: absolute;
      right: 20px;
      font-family: element-icons;
      content: "\e6da";
      font-size: 12px;
      font-weight: 700;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
  }
}
</style>
